(function ($) {
    // Functions:
    // Define our functions for breadcrumb navigation
    function buildToggle() {
        var breadcrumbs = $("#breadcrumbs");
        var toggle_html =
            '<button id="toggle__breadcrumbs" aria-label="Toggle Breadcrumbs" class="toggle__breadcrumbs">';

        // Add the toggle button
        breadcrumbs.find(".wrapper").append(toggle_html);
    }

    function destroyToggle() {
        var breadcrumbs = $("#breadcrumbs");
        var breadcrumb_toggle = $("#toggle__breadcrumbs");

        // Remove the toggle button after unbinding
        breadcrumb_toggle.unbind("click").remove();

        // Remove the classes
        breadcrumbs.removeClass("toggle__breadcrumbs--active");
    }

    function buildPrefix() {
        var current_page = $("#breadcrumbs .wrapper > span:last-of-type");
        var prefix_html =
            '<span id="breadcrumbs__prefix" class="breadcrumbs__prefix">&hellip;<span class="sep">/</sep></span>';

        // Prefix current page
        current_page.prepend(prefix_html);
    }

    function destroyPrefix() {
        var prefix = $("#breadcrumbs__prefix");

        // Remove current page prefix
        prefix.remove();
    }

    function toggleTrail() {
        var breadcrumbs = $("#breadcrumbs");
        var breadcrumb_toggle = $("#toggle__breadcrumbs");

        // Toggle display of breadcrumb when tapping button
        breadcrumb_toggle.click(function () {
            // Toggle the classes
            $(this).toggleClass("toggle__breadcrumbs--active");
            breadcrumbs.toggleClass("breadcrumbs--expanded");
        });
    }

    function patchDateTrail() {
        if ($("body.date")) {
            var post_type = breadcrumbs.post_type;
            var archive = breadcrumbs.archive;
            var year = breadcrumbs.year;
            var month = breadcrumbs.month;
            var day = breadcrumbs.day;
            var date_month = breadcrumbs.date_month;
            var trail = $("#breadcrumbs");
            var trail_part = trail.find('span[typeof="ListItem"]');

            // Day archive
            // -----------------------------------------------------------------------
            if (archive && day > 0) {
                var day_archive_day = trail_part
                    .last()
                    .find('span[property="name"]');
                var day_archive_month = day_archive_day
                    .parent()
                    .prev()
                    .prev()
                    .find('span[property="name"]');
                var day_archive_year = day_archive_month
                    .parent()
                    .parent()
                    .prev()
                    .prev()
                    .find('span[property="name"]');
                var day_archive_month_url =
                    "/" + year + "/" + month + "/?post_type=" + post_type;
                var day_archive_year_url =
                    "/" + year + "/?post_type=" + post_type;

                // fix day trail
                day_archive_day.text(day);

                // fix month trail
                day_archive_month.parent().attr("href", day_archive_month_url);
                day_archive_month
                    .parent()
                    .attr("title", "Go to the " + date_month + " archives");
                day_archive_month.text(date_month);

                // fix year trail
                day_archive_year.parent().attr("href", day_archive_year_url);
                day_archive_year
                    .parent()
                    .attr("title", "Go to the " + year + " archives");
                day_archive_year.text(year);

                // fix events title
                $("body.post-type-archive-events h1.page-title").text(
                    date_month + " " + day + ", " + year
                );
            }

            // Month archive
            // -----------------------------------------------------------------------
            else if (archive && month > 0) {
                var month_archive_month = trail_part
                    .last()
                    .find('span[property="name"]');
                var month_archive_year = month_archive_month
                    .parent()
                    .prev()
                    .prev()
                    .find('span[property="name"]');
                var month_archive_year_url =
                    "/" + year + "/?post_type=" + post_type;

                // fix month trail
                month_archive_month.text(date_month);

                // fix year trail
                month_archive_year
                    .parent()
                    .attr("href", month_archive_year_url);
                month_archive_year
                    .parent()
                    .attr("title", "Go to the " + year + " archives");
                month_archive_year.text(year);

                // fix events title
                $("body.post-type-archive-events h1.page-title").text(
                    date_month + " " + year
                );
            }

            // Year archive
            // -----------------------------------------------------------------------
            else if (archive && year > 0) {
                var year_archive_year = trail_part
                    .last()
                    .find('span[property="name"]');

                // fix year trail
                year_archive_year.text(year);

                // fix events title
                $("body.post-type-archive-events h1.page-title").text(year);
            }
        }
    }

    // Laptop/Desktop:
    // Restructure header to include brand bar and site bar
    enquire.register("screen and (min-width: 1175px)", {
        // =====================================================
        // Triggered when a media query matches
        // =====================================================
        match: function () {
            destroyToggle();
            destroyPrefix();
        },

        // =====================================================
        // Triggered when a media query transitions from a
        // matched state to an unmatched state
        // =====================================================
        unmatch: function () {
            buildToggle();
            buildPrefix();
            toggleTrail();
        },

        // =====================================================
        // Triggered once, when the handler is registered
        // =====================================================
        setup: function () {
            buildToggle();
            buildPrefix();
            toggleTrail();
            patchDateTrail();
        },
    });
})(jQuery);
